/* eslint-disable */
export enum PAGE_TYPE {
  PLA = 'PLA',
  PDP = 'PDP',
  PARTNERS = 'Partners',
  WHISHLIST = 'wishlist',
}
/* eslint-enable */

export type TAnalyticsListIdPage =
  | 'home'
  | 'department'
  | 'category'
  | 'landing'
  | 'daily-sales'
  | 'guide_shop';

export type TPageType = PAGE_TYPE.PLA | PAGE_TYPE.PDP | PAGE_TYPE.PARTNERS;

export const isPageType = (pageType: TPageType, validTypes: TPageType | TPageType[]): boolean => {
  if (Array.isArray(validTypes)) {
    return validTypes.includes(pageType);
  }

  return pageType === validTypes;
};
